const securityConfig = {
  // Enable/disable security features
  enableDevToolsProtection: true,
  enableSecurityWrapper: true,
  
  // Development mode (set to true during development to disable security)
  developmentMode: false, // Temporarily disable for testing
  
  // Security levels - LESS AGGRESSIVE to avoid false positives
  aggressiveMode: false, // Set to false for less aggressive detection
  
  // Detection settings - MORE LENIENT
  detectionThreshold: 200, // ms threshold for debugger detection (increased)
  checkInterval: 5000, // How often to check for DevTools (ms) - less frequent
  initialDelay: 10000, // Wait before starting checks (ms)
  
  // Features to enable/disable - REDUCED BLOCKING
  blockRightClick: true,
  blockTextSelection: false, // Allow text selection
  blockKeyboardShortcuts: true, // Only block DevTools shortcuts
  overrideConsole: false, // Don't override console in normal browsing
  detectAutomationTools: true,
  
  // Messages
  securityViolationMessage: "Access restricted. Developer tools detected.",
  warningMessage: "This application is protected against unauthorized access."
};

export default securityConfig; 